// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1KX26","title":"Images45_title__1-tfU","images":"Images45_images__2TtSS"};